import { RefObject } from 'react'
import { DateOrders, OrderData } from '~/shared/api/services/warehouses/types'
import { AssemblyOrderCard } from './order-card'

interface OrdersByDateSectionProps {
  dates: DateOrders[]
  dateRefs: RefObject<{ [key: string]: HTMLDivElement | null }>
  adaptiveFontSize: (text: string) => string
  onOpenOrder: (order: OrderData) => void
}

export const OrdersByDateSection = ({
  dates,
  dateRefs,
  adaptiveFontSize,
  onOpenOrder,
}: OrdersByDateSectionProps) => {
  return (
    <>
      {dates.map(({ date, orders }) => (
        <div
          key={date}
          ref={(el) => {
            if (el) {
              dateRefs.current[date] = el
            }
          }}
        >
          <p className="my-4 font-medium">{date}</p>
          <div className="flex flex-wrap gap-4">
            {orders.map((order) => (
              <AssemblyOrderCard
                key={order.id}
                order={order}
                className="text-center w-[150px] h-[50px]"
                adaptiveFontSize={adaptiveFontSize}
                onOpen={onOpenOrder}
              />
            ))}
          </div>
        </div>
      ))}
    </>
  )
}
